// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__La2hb","comment":"styles_comment__2U1Xa"};